'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';
import { offlineNotesDB } from '@/lib/offline-notes';

export function ServiceWorkerProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize IndexedDB
    offlineNotesDB.init().then(() => {
      console.log('✅ IndexedDB initialized');
    }).catch(error => {
      console.error('❌ IndexedDB initialization failed:', error);
    });

    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw-notes.js')
        .then((registration) => {
          console.log('✅ Service Worker registered successfully:', registration.scope);

          // Check for updates periodically
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000); // Check every hour
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error);
        });

      // Listen for service worker updates
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('🔄 Service Worker controller changed');
        // toast.info('Aplikacja została zaktualizowana', {
        //   description: 'Odśwież stronę aby zobaczyć zmiany',
        //   icon: '🔄',
        // });
      });
    }
  }, []);

  return <>{children}</>;
}
